import type { AdminUserView } from "@/lib/team/admin-user-view";
import { TeamView } from "@/components/team/team-view";
import { useLoaderData } from "react-router";
import { load } from "../api/load";
import { useAdmin } from "../session";

export function loader() {
  return load<AdminUserView[]>(`/api/v1/admin/team`);
}

export default function TeamPage() {
  const admins = useLoaderData() as AdminUserView[];
  const auth = useAdmin();

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-[22px] font-bold text-white tracking-tight">Team</h1>
        <p className="text-zinc-500 text-[13px] mt-0.5">
          Manage admin accounts. Only owners can add, delete, or reset passwords.
        </p>
      </div>
      <TeamView
        admins={admins}
        currentAdminId={auth.id}
        canMutate={auth.role === "owner"}
      />
    </div>
  );
}
